import MaterialIcon from '@/components/MaterialIcon';
import React from 'react';

/**
 * MetricsSection組件
 * KPI指標展示区域
 *
 * 展示4个关键指标:
 * - 70% 案内所・電話対応削減
 * - 10+ 多言語対応
 * - 0円 専用筐体コスト
 * - 24h 365日無人対応
 */
export const MetricsSection: React.FC = () => {
  return (
    <div className="w-full border-y border-solution-border bg-white py-12">
      <div className="max-w-[1200px] w-full mx-auto px-4 md:px-10 lg:px-40">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center text-solution-text">
          <div className="p-4">
            <p className="text-5xl font-black text-solution-orange mb-1">
              50~70<span className="text-2xl font-bold text-solution-orange/70">%</span>
            </p>
            <p className="text-sm font-medium text-solution-text-secondary">案内所・電話対応削減</p>
          </div>
          <div className="p-4">
            <p className="text-5xl font-black text-solution-orange mb-1">
              10<span className="text-2xl font-bold text-solution-orange/70">+</span>
            </p>
            <p className="text-sm font-medium text-solution-text-secondary">多言語対応 (Inbound)</p>
          </div>
          <div className="p-4">
            <p className="text-5xl font-black text-solution-orange mb-1">
              <MaterialIcon name="devices" className="text-solution-orange text-4xl" />
            </p>
            <p className="text-sm font-medium text-solution-text-secondary">PC・スマホ・大型タッチパネル対応</p>
          </div>
          <div className="p-4">
            <p className="text-5xl font-black text-solution-orange mb-1">
              1<span className="text-2xl font-bold text-solution-orange/70">秒</span>
            </p>
            <p className="text-sm font-medium text-solution-text-secondary">365日 無人対応</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MetricsSection;
